import ArticlePage from "./ArticlePage";
import { links, pages, person, navLinks } from "../data/site";
import {
  breadcrumbSchema,
  buildGraph,
  webpageSchema,
} from "../data/schema";

const ContactPage = () => {
  const seo = pages.contact;
  const schema = buildGraph([
    webpageSchema(seo),
    breadcrumbSchema([
      { name: "Home", path: "/" },
      { name: "Contact", path: seo.path },
    ]),
  ]);

  return (
    <ArticlePage
      seo={seo}
      schema={schema}
      theme="light"
      bigTitle="HELLO"
      heading="Contact Hareesh Rajendran"
      related={navLinks.filter((link) => link.to !== seo.path)}
    >
      <p>
        {person.name} is based in {person.location}. The fastest public channels
        are email and YouTube.
      </p>
      <ul>
        <li>
          Email:{" "}
          <a href={`mailto:${person.email}`}>{person.email}</a>
        </li>
        <li>
          Vanakkam DSA:{" "}
          <a href={links.vanakkamDsa} target="_blank" rel="noopener noreferrer me">
            vanakkamdsa.com
          </a>
        </li>
        <li>
          GitHub:{" "}
          <a href={links.github} target="_blank" rel="noopener noreferrer me">
            github.com/hareesh-r
          </a>
        </li>
        <li>
          LinkedIn:{" "}
          <a href={links.linkedin} target="_blank" rel="noopener noreferrer me">
            linkedin.com/in/hareesh-r
          </a>
        </li>
        <li>
          LeetCode:{" "}
          <a href={links.leetcode} target="_blank" rel="noopener noreferrer me">
            leetcode.com/u/hareeshprogrammer
          </a>
        </li>
        <li>
          X:{" "}
          <a href={links.x} target="_blank" rel="noopener noreferrer me">
            @hareesh_dev
          </a>
        </li>
        <li>
          Instagram:{" "}
          <a href={links.instagram} target="_blank" rel="noopener noreferrer me">
            @hareeshrajendran_
          </a>
        </li>
        <li>
          YouTube:{" "}
          <a href={links.youtube} target="_blank" rel="noopener noreferrer me">
            @hareeshrajendran
          </a>
        </li>
      </ul>
    </ArticlePage>
  );
};

export default ContactPage;
